<script>
  import { onMount } from 'svelte';
  import Icon from './Icon.svelte';
  import NotePercent from './NotePercent.svelte';
  import { scaleSqrt } from 'd3-scale';
  import {yesterdayURL, debounce, reduceData, getStickerSize} from './settings';
  let loading = true;
  let error = false;
  let day = null;
  let count = null;
  let meloniChartData = [];
  let schleinChartData = [];
  let content = {};
  let articolo = 'Il ';

  const draw = () => {
    const size = getStickerSize();
    let format = { day: 'numeric', month: 'long', year: 'numeric' };
    const dateFromDB = new Date(content.data.date)
    day = new Intl.DateTimeFormat('it-IT', format).format(dateFromDB);
    const dayNumber = dateFromDB.getDate();
    if (
      dayNumber === 1 ||
      dayNumber === 8 ||
      dayNumber === 1
    ) {
      articolo = 'L\'';
    }

    // const totalMeloni = content.data.meloni.reduce((a, d) => (a + d.count), 0);
    // const totalSchlein =  content.data.schlein.reduce((a, d) => (a + d.count), 0);
    const totalCount = content.data.count; // totalMeloni + totalSchlein;
    const radius = scaleSqrt()
      .domain([0, 1])
      .range(size);
    
    meloniChartData = reduceData('meloni', radius, content, totalCount);
    schleinChartData = reduceData('schlein', radius, content, totalCount);
    loading = false;
  };

  const debouncedSetWindowWidth = debounce(draw, 300);

  onMount(async () => {
    try {
      const response = await fetch(yesterdayURL);
      content = await response.json();
      if (content.error) {
        console.warn(content.error);
        loading = false;
        error = true;
      } else {
        count = new Intl.NumberFormat('it-IT', (content.data.count > 10000 ? { notation: 'compact' } : {})).format(content.data.count);
        draw();       
      }
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
    window.addEventListener('resize', debouncedSetWindowWidth);		
		return () => {
			window.removeEventListener('resize', debouncedSetWindowWidth);
		}
  })
</script>

<div id="yesterday" class="{loading ? 'loading' : ''}">
  {#if error}
    <p class="error">C'è stato un problema nel caricamento dei dati, per favore riprova più tardi.</p>
  {:else}
    <div class="yesterday--content">
      <div class="yesterday--text">
        <p class="data">{articolo}<strong>{day}</strong> è l'ultimo giorno per cui abbiamo dati. Abbiamo
          raccolto <strong>{count} news</strong> che parlano delle nostre protagoniste:</p>
      </div>
      <div class="yesterday--chart">
        <div class="yesterday--meloni">          
          {#each meloniChartData as m, index}
            <div
              class="yesterday--icon icon-{index} {m.v === 0 ? 'zero' : ''}"
              style="width: {m.w}px; height: {m.w}px">
              <Icon sentiment={m.sentiment} src="meloni" />
              <div class="value {m.sentiment}">{m.val}</div>
              {#if index === 0}<h3>Giorgia Meloni</h3>{/if}
            </div>
          {/each}
        </div>
        <div class="yesterday--schlein">
          {#each schleinChartData as s, index}
            <div
              class="yesterday--icon icon-{index} {s.v === 0 ? 'zero' : ''}"
              style="width: {s.w}px; height: {s.w}px">
              <Icon sentiment={s.sentiment} src="schlein" />
              <div class="value {s.sentiment}">{s.val}</div>
              {#if index === 0}<h3>Elly Schlein</h3>{/if}
            </div>
          {/each}
        </div>
      </div>
      <NotePercent />
    </div>
  {/if}
</div>

<style>
  #yesterday {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    margin: 0 20px;
    opacity: 1;
    padding: 10vh 0;
    transition: opacity .5s ease-in-out;
    width: auto;
  }

  #yesterday.loading {
    opacity: 0;
  }

  .yesterday--content {
    width: 100%;
  }

  .yesterday--chart {
    display: flex;
    flex-direction: column;
    height: 80vh;
    justify-content: space-between;
    width: 100%;
  }

  .yesterday--meloni,
  .yesterday--schlein {
    flex: 0 0 50%;
    height: 30vh;
    position: relative;
  }

  .yesterday--icon {
    display: block;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  .yesterday--icon.icon-0 {
    z-index: 3;
  }

  .yesterday--icon.icon-1 {
    left: 20%;
    z-index: 2;
  }

  .yesterday--icon.icon-2 {
    left: 80%;
    z-index: 1;
  }

  .yesterday--icon .value {
    color: var(--neutral);
    font-family: 'Fira Mono', monospace;
    font-weight: 500;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 100%;
    transform: translate3d(-50%, 0, 0);
  }

  .yesterday--icon h3 {
    bottom: 100%;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translate3d(-50%, -10px, 0);
  }

  .yesterday--icon .value.positive {
    color: var(--positive);
  }

  .yesterday--icon .value.negative {
    color: var(--negative);
  }

  @media screen and (min-width: 768px) {
    #yesterday {
      max-width: 960px;
    }
  }

  @media screen and (min-width: 1024px) {
    #yesterday {
      margin: 0 auto;
      width: 100%;
    }

    .yesterday--chart {
      flex-direction: row;
      height: auto;
    }

    .yesterday--meloni,
    .yesterday--schlein {
      flex: 0 0 45%;
      height: 380px;
      padding-top: 100px;
    }
  }
</style>